export * from './user-picture.component';



// WEBPACK FOOTER //
// ./src/app/components/user-picture/index.ts